import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfBillboard.module.scss';
import { Image, Container } from '@/components';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import eagerLoadChildImages from '@/helpers/eagerLoadChildImages';
import structuredClone from '@ungap/structured-clone';

let cx = classNames.bind(styles);

export default function AcfBillboard(props) {
	const { billboard, attributes, innerBlocks } = props;
	const className = attributes.className?.split(' ') || [];

	const bgImageFitDesk = billboard.desktopImageSettings?.objectFit && billboard.desktopImageSettings?.objectFit[0];

	const innerBlocksWithImageLoading = eagerLoadChildImages(structuredClone(innerBlocks));

	const style = {};
	style['--minBillboardHeightDesk'] = billboard.desktopImageSettings.minimumHeight ? `${billboard.desktopImageSettings.minimumHeight}px` : '0px';

	return (
		<div id={attributes.anchor} className={cx(['ns_billboard', 'billboard', ...className, billboard.reverseTextColor && 'is-dark', billboard.desktopImageSettings?.desktop && `image-display-${billboard.desktopImageSettings.desktop}--desk`, billboard.desktopImageSettings?.mobile && `image-display-${billboard.desktopImageSettings.mobile}--mobile`, attributes.billboardAlign && `align-${attributes.billboardAlign}`, billboard.mobileImageSettings.imagePosition && `mobile-image-${billboard.mobileImageSettings.imagePosition}`])} style={style}>
			<Container className={cx('billboard-container')}>
				<WordPressBlocksViewer blocks={innerBlocksWithImageLoading ?? []} />
			</Container>
			{billboard.mobileImage && (
				<div className={cx(['billboard-mobile-image'])}>
					<Image image={billboard.mobileImage} className={cx(['billboard-background--mobile', attributes.billboardAlign && 'is-style-rounded'])} loading="eager" />
				</div>
			)}
			{billboard.desktopImage && <Image image={billboard.desktopImage} objectFit={bgImageFitDesk} fill={true} objectPosition={`${billboard.desktopImageSettings?.objectPositionX}% ${billboard.desktopImageSettings?.objectPositionY}%`} className={cx(['billboard-background', attributes.billboardAlign && 'is-style-rounded'])} loading="eager" />}
		</div>
	);
}

AcfBillboard.fragments = {
	key: `AcfBillboardFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfBillboardFragment on AcfBillboard {
			attributes {
				anchor
				className
				billboardAlign: align
			}
			billboard {
				desktopImage {
					...ImageFragment
				}
				desktopImageSettings {
					objectFit
					objectPositionX
					objectPositionY
          minimumHeight
				}
				mobileImage {
					...ImageFragment
				}
				mobileImageSettings {
					imagePosition
				}
				reverseTextColor
			}
		}
	`,
};

AcfBillboard.config = {
	name: 'AcfBillboard',
};
AcfBillboard.displayName = 'AcfBillboard';
